"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncActionTypeKey = createAsyncActionTypeKey;
exports.createAsyncActionTypeValue = createAsyncActionTypeValue;
exports.createAsyncActionTypesMap = createAsyncActionTypesMap;
exports.createAsyncActionTypes = createAsyncActionTypes;
exports.createDeleteActionTypes = createDeleteActionTypes;
exports.createGetActionTypes = createGetActionTypes;
exports.createPatchActionTypes = createPatchActionTypes;
exports.createPostActionTypes = createPostActionTypes;
exports.createPutActionTypes = createPutActionTypes;
const ActionMethods_1 = require("../types/ActionMethods.js");
const lib_1 = require("../../lib/string/lib.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
function createAsyncActionTypeKey(options) {
    const { actionMethod, httpVerb, name } = options;
    return `${actionMethod}_${httpVerb.toLowerCase()}_${name}`.toUpperCase();
}
function createAsyncActionTypeValue(options) {
    const { actionMethod, httpVerb, name } = options;
    const actionMethodLowercase = actionMethod.toLowerCase();
    const httpVerbCapialized = (0, lib_1.capitalize)(httpVerb.toLowerCase());
    const nameCapitalized = (0, lib_1.capitalize)(name);
    return `${actionMethodLowercase}${httpVerbCapialized}${nameCapitalized}`;
}
function createAsyncActionTypesMap(options) {
    return {
        [ActionMethods_1.AsyncActionMethods.Error]: createAsyncActionTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Error }, options)),
        [ActionMethods_1.AsyncActionMethods.Failed]: createAsyncActionTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Failed }, options)),
        [ActionMethods_1.AsyncActionMethods.Receive]: createAsyncActionTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Receive }, options)),
        [ActionMethods_1.AsyncActionMethods.Repeat]: createAsyncActionTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Repeat }, options)),
        [ActionMethods_1.AsyncActionMethods.Request]: createAsyncActionTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Request }, options)),
        [ActionMethods_1.AsyncActionMethods.Reset]: createAsyncActionTypeValue(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Reset }, options))
    };
}
function createAsyncActionTypes(options) {
    const map = createAsyncActionTypesMap(options);
    return {
        [createAsyncActionTypeKey(Object.assign(Object.assign({}, options), { actionMethod: ActionMethods_1.AsyncActionMethods.Error }))]: map.error,
        [createAsyncActionTypeKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Failed }, options))]: map.failed,
        [createAsyncActionTypeKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Receive }, options))]: map.receive,
        [createAsyncActionTypeKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Request }, options))]: map.request,
        [createAsyncActionTypeKey(Object.assign({ actionMethod: ActionMethods_1.AsyncActionMethods.Reset }, options))]: map.reset
    };
}
function createDeleteActionTypes(options) {
    return createAsyncActionTypes(Object.assign({ httpVerb: sonar_http_1.HttpVerb.Delete }, options));
}
function createGetActionTypes(options) {
    return createAsyncActionTypes(Object.assign({ httpVerb: sonar_http_1.HttpVerb.Get }, options));
}
function createPatchActionTypes(options) {
    return createAsyncActionTypes(Object.assign({ httpVerb: sonar_http_1.HttpVerb.Patch }, options));
}
function createPostActionTypes(options) {
    return createAsyncActionTypes(Object.assign({ httpVerb: sonar_http_1.HttpVerb.Post }, options));
}
function createPutActionTypes(options) {
    return createAsyncActionTypes(Object.assign({ httpVerb: sonar_http_1.HttpVerb.Put }, options));
}
//# sourceMappingURL=lib.js.map